var _circle, _circle2, _circle3, _path, _circle4, _circle5, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCryingCircly(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 77,
    height: 50,
    viewBox: "0 0 77 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1656,
    cy: 18.1656,
    r: 14.6656,
    fill: "white",
    stroke: "#7858FB",
    strokeWidth: 7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.7996,
    cy: 18.1656,
    r: 14.6656,
    fill: "white",
    stroke: "#7858FB",
    strokeWidth: 7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.2571,
    cy: 24.2571,
    r: 8.25708,
    fill: "#322C3A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5142 24.2571C66.5142 28.8173 62.8173 32.5142 58.2571 32.5142C53.6968 32.5142 50 28.8173 50 24.2571C50 19.6968 53.6968 16 58.2571 16C62.8173 16 66.5142 19.6968 66.5142 24.2571Z",
    fill: "#322C3A"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 58.1656,
    cy: 18.1656,
    r: 14.6656,
    stroke: "#7858FB",
    strokeWidth: 7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.1656,
    cy: 18.1656,
    r: 14.6656,
    stroke: "#7858FB",
    strokeWidth: 7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0078 31.3435L64.0761 26.2068L61.7229 32.9276C61.3597 33.9696 61.2743 35.182 61.5428 36.4167C62.2057 39.4654 64.7753 41.495 67.2821 40.9499C69.7889 40.4047 71.2836 37.4914 70.6206 34.4426C70.3521 33.208 69.7709 32.1405 69.0078 31.3435Z",
    fill: "#349EFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6874 43.1108L61.145 39.0142L58.6397 43.1336C58.2524 43.7725 58.0251 44.5634 58.0289 45.4189C58.0385 47.5313 59.4543 49.2374 61.1912 49.2295C62.9281 49.2217 64.3284 47.5028 64.3189 45.3904C64.315 44.5349 64.0805 43.7461 63.6874 43.1108Z",
    fill: "#349EFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6408 32.9484L11.346 26.2074L6.3699 31.301C5.59992 32.0915 5.00947 33.1538 4.73027 34.3861C4.04085 37.429 5.51021 40.3552 8.01215 40.9221C10.5141 41.4889 13.1012 39.4818 13.7906 36.4389C14.0698 35.2066 13.9949 33.9935 13.6408 32.9484Z",
    fill: "#349EFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3806 42.0216L14.975 38.0135L12.6058 42.0432C12.2395 42.6682 12.0245 43.4419 12.0283 44.2789C12.0376 46.3455 13.3772 48.0148 15.0202 48.0074C16.6632 48 17.9876 46.3186 17.9782 44.2519C17.9744 43.415 17.7525 42.6432 17.3806 42.0216Z",
    fill: "#349EFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCryingCircly);
export default __webpack_public_path__ + "static/media/crying_circly.ab38308a43b3e35ec46d349d13a0f7a9.svg";
export { ForwardRef as ReactComponent };